import { isEmployeeContractByType, isPolishOffice } from 'domain/shared/employee';
import { PAID_LEAVE_SUB_TYPES, PAID_LEAVE_SUB_TYPES_ALIAS } from 'domain/shared/leave/constants';

export function isPolishEcEmployee(employee?: { officeId?: string | number; contractType?: string }): boolean {
  if (!employee?.officeId || !employee?.contractType) {
    return false;
  }

  return isPolishOffice(String(employee.officeId)) && isEmployeeContractByType(String(employee.contractType));
}

export function paidLeaveSubtypeOptions(isPolishAndEc: boolean): Partial<typeof PAID_LEAVE_SUB_TYPES> {
  return {
    [PAID_LEAVE_SUB_TYPES_ALIAS.REGULAR_PAID_LEAVE]: PAID_LEAVE_SUB_TYPES.REGULAR_PAID_LEAVE,
    [PAID_LEAVE_SUB_TYPES_ALIAS.COMPENSATION]: PAID_LEAVE_SUB_TYPES.COMPENSATION,
    ...(isPolishAndEc ? { [PAID_LEAVE_SUB_TYPES_ALIAS.DAY_ON_DEMAND]: PAID_LEAVE_SUB_TYPES.DAY_ON_DEMAND } : {}),
  };
}
